import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const CompanySettingsContext = createContext(null);

export const useCompanySettings = () => {
  const context = useContext(CompanySettingsContext);
  if (!context) {
    // Return default values if not within provider
    return {
      timezone: 'America/Los_Angeles',
      dateFormat: 'MM/DD/YYYY',
      currency: 'USD',
      companyName: '',
      loading: true,
      refetch: () => {}
    };
  }
  return context;
};

export const CompanySettingsProvider = ({ children }) => {
  const { api, user, isAuthenticated } = useAuth();
  const [settings, setSettings] = useState({
    timezone: 'America/Los_Angeles',
    dateFormat: 'MM/DD/YYYY',
    currency: 'USD',
    companyName: '',
  });
  const [loading, setLoading] = useState(true);

  const fetchCompanySettings = useCallback(async () => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }

    try {
      const response = await api.get('/company');
      if (response.data) {
        setSettings({
          timezone: response.data.timezone || 'America/Los_Angeles',
          dateFormat: response.data.date_format || 'MM/DD/YYYY',
          currency: response.data.currency || 'USD',
          companyName: response.data.name || '',
        });
      }
    } catch (error) {
      // Company not set up yet or error - use defaults
      console.log('Company settings not available, using defaults');
    } finally {
      setLoading(false);
    }
  }, [api, isAuthenticated]);

  useEffect(() => {
    fetchCompanySettings();
  }, [fetchCompanySettings]);

  const value = {
    timezone: settings.timezone,
    dateFormat: settings.dateFormat,
    currency: settings.currency,
    companyName: settings.companyName,
    loading,
    refetch: fetchCompanySettings
  };

  return (
    <CompanySettingsContext.Provider value={value}>
      {children}
    </CompanySettingsContext.Provider>
  );
};

export default CompanySettingsContext;
